import * as React from "react";
import Owner from "@/components/organisms/owner";
import { OwnerProvider } from "@/context/OwnerContext";

export default function OwnerPage() {
  return (
    <OwnerProvider>
      <Owner />
    </OwnerProvider>
  );
}
